module.exports = __webpack_public_path__ + "static/media/joao.30698365.jpg";